import moment from "moment"
import ModalImage from "react-modal-image";
import { AiTwotoneHeart } from "react-icons/ai"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"
import Collection from "../V2Leaderboard/Collection";
import { useSelector } from "react-redux";
import { SentenceCase } from "../../utility/helper_functions";
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5";
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage";
import { Tooltip } from "react-tooltip";
import ForecastShareTool from "./components/ForecastShareTooltip";

const NewsFeedImage = ({ image, allCollectionNames, addImageToCollection, collectionSets, fetchCollections, trendType, setLightBoxImageIndex, index, type = 'social', category = '' }) => {
  const userLoggedIn = useSelector(state => state.userLoggedIn)
  return <div className='mr-2 max-[500px]:mr-1 max-w-full min-w-max text-center'>
    {
      trendType == 'retailer' && image.forecastScore && false ?
        <ForecastShareTool image={image} />
        : null
    }

    <div className='flex  flex-col items-end min-h-60' style={{ minHeight: '17.5rem' }}>
      <div className="relative w-full" data-tooltip-id={'trends-tooltip-' + (trendType == 'social' ? image.mediaId : image.pk)}>
        <Collection image={image} collections={allCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
        <img
          src={image.imageUrl}
          loading='lazy'
          className=' h-[25rem] my-1'
          onClick={() => {
            if (setLightBoxImageIndex)
              setLightBoxImageIndex(index)
          }}
        />
      </div>
      <ImageTagsDetails mediaId={image.mediaId} isretailer={trendType != 'social'} />
    </div>
    {
      trendType == 'social' ? <a className='mx-2 flex justify-evenly items-center m-0 font-bold hover:extrabold hover:underline-offset-8 hover:cursor-pointer' href={image.postUrl} target="_blank" rel="noopener noreferrer">
        <div>
          <div className='flex items-center'>{image.hasOwnProperty('countOfLikes') && parseInt(image.countOfLikes) > 3 ? <>{image.countOfLikes}<span className=' text-red-600 text-xl'><AiTwotoneHeart /></span></> : null}</div>
        </div>
        <div>
          <div className='flex items-center'>{image.username}<span className='text-xl'></span></div>
        </div>
        <div>
          {/* <div className='flex items-center'>{image.noOfComments}<span className='text-xl'><BiCommentDots /></span></div> */}
        </div>
      </a> : <a className='text-left mx-2 flex justify-evenly items-center m-0 font-bold hover:extrabold hover:underline-offset-8 hover:cursor-pointer' href={image.postUrl} target="_blank" rel="noopener noreferrer">
        <div className="w-full">

          {['sales', 'reviews', 'bestsellerRank', 'retailerHashtag'].map(item => <div key={item} hidden={!image[item]} className={`max-w-40 text-[14px] ${item != "retailerHashtag" ? "font-semibold" : "font-normal"}`}><span className="font-semibold hidden lg:inline">{item != 'bestsellerRank' ? <span>{item}: </span> : null}</span>{item == "retailerHashtag" ? "#" : ""}{image[item]}</div>)}

          <div className='text-[12px] font-medium'><span className="font-semibold hidden lg:inline">Retailer : </span>{image.retailer}</div>
          <div className='text-[12px] font-medium'><span className="font-semibold hidden lg:inline">Brand : </span>{image.username}</div>
          {['price', 'title'].map(item => <div key={item} hidden={!image[item]} className={`font-medium ${item == 'title' ? 'text-nowrap overflow-hidden' : ''} max-w-40 text-[12px]`} style={item == 'title' ? { maxWidth: '10rem', textWrap: 'nowrap', overflow: 'hidden' } : {}}><span className="font-semibold hidden lg:inline">{item}: </span>{image[item]}</div>)}
          <div className={`flex font-medium  max-w-40 text-[12px]`}><span className="font-semibold hidden lg:inline text-nowrap mr-1">Product Code: </span><span className="text-red-500">{image.mediaId}</span></div>
        </div>
      </a>
    }

    {false ? <p hidden={trendType == 'retailer'}>{moment(trendType == 'social' ? image.timeStamp : image.insertDate).format("DD MMM YYYY")}</p> : null}
    {
      image.city ? <div className="text-center">
        <div className='text-center'><span className="font-semibold">City:</span> {SentenceCase(image.city)}</div>
      </div> : null
    }
    <div
      className='text-[12px] font-medium text-left px-2'
      data-tooltip-id={'forecast-tooltip-' + image.mediaId}
    >
      Forecast Score : {image.forecastScore && image.forecastScore[category] ? <span className=" text-red-500">{roundtocloses0_5_value(showFloatToPercentage(image.forecastScore[category]))}</span> : 0}
      <div className="text-[12px] mb-2">
        {
          false && image.forecastScore ? Object.keys(image.forecastScore)
            .map((category, i) => <div key={category} className="flex justify-between border-b pl-2">
              <div><p className="text-wrap pr-2 flex">{i + 1}. {category} Forecast score</p></div>
              <div className="text-center">{roundtocloses0_5_value(showFloatToPercentage(image.forecastScore[category]))}</div>
            </div >) : null}
      </div>
    </div>
    {userLoggedIn && userLoggedIn.curator ? <ImageTagsDetails mediaId={image.mediaId} isretailer={trendType == 'retailer'} className="block" /> : null}
  </div >

}
export default NewsFeedImage
